/**
 * @prettier
 */

/**
 * Defining form validation rules for Group Link Send page
 *
 * @type object
 */
const groupLinkSend = {
    "group-link-send-name": {
        name: "idpal_name",
        id: "group-link-send-name",
        required: true,
        min: 1,
        max: 50,
        regex: "^[\\p{Script=Han}\\p{Script=Latin} ,.'’\\-]+$",
        messages: {
            regex: "idpal_allowed_characters_letters_error",
        },
    },
    "group-link-send-email": {
        name: "idpal_email",
        id: "group-link-send-email",
        required: true,
        regex: "^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$",
        messages: {
            regex: "idpal_invalid_email_format",
        },
    },
};

export { groupLinkSend };
